import { render, staticRenderFns } from "./ChallengeHistory.vue?vue&type=template&id=37499104&scoped=true&"
import script from "./ChallengeHistory.vue?vue&type=script&lang=js&"
export * from "./ChallengeHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeHistory.vue?vue&type=style&index=0&id=37499104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37499104",
  null
  
)

export default component.exports